import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { useWeb3React } from "@web3-react/core";
import { getContracts } from "../../utils/getContracts";

const CurrentRound = () => {
  const { account } = useWeb3React();
  const web3 = useWeb3();

  const currentRound = useCallback(
    async (project) => {
      try {
        const { contract } = getContracts(project, web3);

        if (!contract) {
          throw new Error(`Contract not found for project: ${project}`);
        }

        const roundCount = await contract.methods.getRoundCount().call();
        // console.log(roundCount, "roundCount");
        return roundCount;
      } catch (error) {
        console.error(`Error getting round count for ${project}:`, error);
        throw error;
      }
    },
    [web3, account] // Keep account if other code depends on it
  );

  return { currentRound };
};

export default CurrentRound;
// import { useCallback, useState } from "react";
// import useWeb3 from "../useWeb3";
// import {
//   getGEMSPreSaleContract,
//   getPreSaleContract,
//   getLEIAPreSaleContract,
//   getOlympusPreSaleContract,
//   getNFAPreSaleContract,
//   getAstroNovaPreSaleContract,
//   getRainPreSaleContract,
//   getMatchainContract,
//   getLuckifyContract,
//   getScrexContract
// } from "../../utils/contractHelpers";
// import { useWeb3React } from "@web3-react/core";
// import Environment from "../../utils/Environment";

// const CurrentRound = () => {
//   const [balance, setBalance] = useState(null);
//   const { account } = useWeb3React();
//   const web3 = useWeb3();
//   const tokenAddress = Environment.PreSale;
//   const incentivContractPresale = getPreSaleContract(tokenAddress, web3);
//   const tokenAddressMatchain = Environment.MATCHAINPreSale;
//   const matchainContractPresale = getMatchainContract(tokenAddressMatchain, web3);
//   const luckifyContractPresale = getLuckifyContract(Environment.LUCKIFYPreSale, web3);
//   const ScrexContractPresale = getScrexContract(Environment.SCREXPreSale, web3);
//   const tokenAddressGEMS = Environment.GemsPreSale;
//   const GEMSContractPresale = getGEMSPreSaleContract(tokenAddressGEMS, web3);

//   const tokenAddressLEIA = Environment.LEIAPreSale;
//   const LEIAContractPresale = getLEIAPreSaleContract(tokenAddressLEIA, web3);

//   const tokenAddressOlympus = Environment.OlympusPreSale;
//   const OlympusContractPresale = getOlympusPreSaleContract(
//     tokenAddressOlympus,
//     web3
//   );

//   const tokenAddressNFA = Environment.NFAPreSale;
//   const NFAContractPresale = getNFAPreSaleContract(tokenAddressNFA, web3);

//   const tokenAddressAstroNova = Environment.AstroNovaPreSale;
//   const AstroNovaContractPresale = getAstroNovaPreSaleContract(
//     tokenAddressAstroNova,
//     web3
//   );

//   const tokenAddressRain = Environment.RainPreSale;
//   const RainContractPresale = getRainPreSaleContract(tokenAddressRain, web3);

//   // const project = localStorage.getItem("project");

//   const currentRound = useCallback(
//     async (proj) => {
//       if (proj == "MATCHAIN") {
//         try {
//           const buy = await matchainContractPresale.methods
//             .getRoundCount()
//             .call();
//           return buy;
//         } catch (error) {
//           // console.log("dlsflasdfjlasdf", error);
//           throw error;
//         }
//       } else if (proj == "LUCKIFY") {
//         try {
//           const buy = await luckifyContractPresale.methods
//             .getRoundCount()
//             .call();
//           return buy;
//         } catch (error) {
//           // console.log("dlsflasdfjlasdf", error);
//           throw error;
//         }
//       }
//       else if (proj == "SCREX") {
//         try {
//           const buy = await ScrexContractPresale.methods
//             .getRoundCount()
//             .call();
//           return buy;
//         } catch (error) {
//           // console.log("dlsflasdfjlasdf", error);
//           throw error;
//         }
//       }
//       else if (proj == "INCENTIV") {
//         try {
//           const buy = await incentivContractPresale.methods
//             .getRoundCount()
//             .call();
//           return buy;
//         } catch (error) {
//           // console.log("dlsflasdfjlasdf", error);
//           throw error;
//         }
//       } else if (proj == "OLYMPUS") {
//         try {
//           const buy = await OlympusContractPresale.methods
//             .getRoundCount()
//             .call();

//           return buy;
//         } catch (error) {
//           // console.log("dlsflasdfjlasdf", error);
//           throw error;
//         }
//       } else if (proj == "LEIA") {
//         try {
//           const buy = await LEIAContractPresale.methods.getRoundCount().call();

//           return buy;
//         } catch (error) {
//           // console.log("dlsflasdfjlasdf", error);
//           throw error;
//         }
//       } else if (proj == "NFA") {
//         try {
//           const buy = await NFAContractPresale.methods.getRoundCount().call();

//           return buy;
//         } catch (error) {
//           // console.log("dlsflasdfjlasdf", error);
//           throw error;
//         }
//       } else if (proj == "ASTRANOVA") {
//         try {
//           const buy = await AstroNovaContractPresale.methods
//             .getRoundCount()
//             .call();

//           return buy;
//         } catch (error) {
//           // console.log("dlsflasdfjlasdf", error);
//           throw error;
//         }
//       } else if (proj == "RAIN") {
//         try {
//           const buy = await RainContractPresale.methods.getRoundCount().call();

//           return buy;
//         } catch (error) {
//           // console.log("dlsflasdfjlasdf", error);
//           throw error;
//         }
//       } else if (proj == "GEMS") {
//         try {
//           const buy = await GEMSContractPresale.methods.getRoundCount().call();

//           return buy;
//         } catch (error) {
//           // console.log("dlsflasdfjlasdf", error);
//           throw error;
//         }
//       }
//     },
//     [LEIAContractPresale, incentivContractPresale, account, web3]
//   );
//   return { currentRound: currentRound };
// };
// export default CurrentRound;
